var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeDropdown,
          expression: "closeDropdown"
        }
      ],
      on: {
        click: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onClickPrevent.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "v-select",
        _vm._b(
          {
            ref: _vm.uid,
            class: { "invalid-state": _vm.state === false },
            attrs: {
              type: "text",
              "item-text": _vm.attributeSearch1,
              "persistent-hint": "",
              ref: "select",
              id: _vm.uid,
              uid: _vm.uid,
              placeholder: _vm.placeholder,
              "menu-props": "auto",
              searchable: _vm.searchable,
              options: _vm.localOptions,
              label: "label",
              loading: _vm.isLoading,
              disabled: _vm.disabled,
              valueProp: _vm.valueProp,
              getOptionLabel: function(option) {
                return option.label
              },
              clearable: _vm.clearable,
              "append-to-body": _vm.autoDropdownPlacement,
              reduce: _vm.reduce,
              filter: _vm.filter,
              "calculate-position": _vm.calcPositionWithPopper,
              multiple: _vm.multiple
            },
            on: {
              open: function($event) {
                return _vm.$emit("open", $event)
              },
              search: function($event) {
                return _vm.$emit("search", $event)
              },
              "option:selected": function($event) {
                return _vm.$emit("option:selected", $event)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "option",
                  fn: function(option) {
                    return [_vm._t("option", null, { option: option })]
                  }
                },
                {
                  key: "no-options",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n       " +
                          _vm._s(
                            _vm.noOptionsTitle || _vm.$t("signupOH.no-options")
                          ) +
                          "\n     "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "open-indicator",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    return [
                      _c("span", _vm._b({}, "span", attributes, false), [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "12",
                              height: "6",
                              viewBox: "0 0 12 6"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                id: "Path_4_Copy",
                                "data-name": "Path 4 Copy",
                                d: "M0,0,6,6,0,12Z",
                                transform: "translate(12) rotate(90)",
                                fill: "#8a8a8a"
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          },
          "v-select",
          _vm.selectAttributes,
          false
        )
      ),
      _vm._v(" "),
      _c("b-form-invalid-feedback", { attrs: { state: _vm.state } }, [
        _vm._v("\n     " + _vm._s(_vm.errorMsg) + "\n   ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ae28b4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ae28b4b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/BaseSelect.vue
// module id = 1564
// module chunks = 116